"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _AccordionActions.default;
  }
});

var _AccordionActions = _interopRequireDefault(require("./AccordionActions"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/AccordionActions/index.js
// module id = 431
// module chunks = 0